// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/extract-text-webpack-plugin/loader.js?{"omit":1,"extract":true,"remove":true}!./~/vue-style-loader!./~/css-loader?sourceMap!./~/vue-loader/lib/style-rewriter.js?id=data-v-30bbb9d3!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/app.vue
// module id = 1364
// module chunks = 50